import { LotacaoFolhaRosto } from 'view/atendimentos/detail/folha-rosto/model'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { SolicitacaoExameQueryModel } from '../../objetivo/resultados-exames/model-resultadosExames'
import {
  convertSolicitacaoFromAtendToSolicitacaoWithInfo,
  convertSolicitacaoFromQueryToSolicitacaoWithInfo,
} from './converter-solicitacaoExames'
import {
  CODIGO_CITOPATOLOGICOS,
  CODIGO_MAMOGRAFIAS,
  CODIGOS_GERAM_REQUISICAO,
  ItemHistoricoSolicitacaoExameModel,
  SolicitacaoExameModel,
} from './model-solicitacaoExames'

export const joinSolicitacoesExame = (
  solicitacoesExameFromQuery: ReadonlyArray<SolicitacaoExameQueryModel>,
  solicitacoesExameFromAtend: SolicitacaoExameModel[],
  props?: { dataReferencia: Instant; atendimentoProfissionalId: ID; lotacao: LotacaoAtendimento | LotacaoFolhaRosto }
) => {
  const { dataReferencia, atendimentoProfissionalId, lotacao } = props ?? {}

  const solicitacoesExameWithMoreInfoFromQuery: ItemHistoricoSolicitacaoExameModel[] = convertSolicitacaoFromQueryToSolicitacaoWithInfo(
    solicitacoesExameFromQuery
  )
  const solicitacoesExameWithMoreInfoFromAtend: ItemHistoricoSolicitacaoExameModel[] = convertSolicitacaoFromAtendToSolicitacaoWithInfo(
    solicitacoesExameFromAtend,
    { dataReferencia, atendimentoProfissionalId, lotacao }
  )

  return [...solicitacoesExameWithMoreInfoFromAtend.reverse(), ...solicitacoesExameWithMoreInfoFromQuery]
}

export const hasExameGeraRequisicao = (solicitacaoExame: ItemHistoricoSolicitacaoExameModel) => {
  return CODIGOS_GERAM_REQUISICAO.some((codigo) => solicitacaoExame.codigos.includes(codigo))
}

export const hasCitopatologicoCode = (solicitacaoExame: ItemHistoricoSolicitacaoExameModel) => {
  return CODIGO_CITOPATOLOGICOS.some((codigo) => solicitacaoExame.codigos.includes(codigo))
}

export const hasMamografiaCode = (solicitacaoExame: ItemHistoricoSolicitacaoExameModel) => {
  return CODIGO_MAMOGRAFIAS.some((codigo) => solicitacaoExame.codigos.includes(codigo))
}

export const hasCitopatologico = (solicitacoes: ItemHistoricoSolicitacaoExameModel[]) => {
  return solicitacoes.some((solicitacaoExame) => hasCitopatologicoCode(solicitacaoExame))
}

export const hasMamografia = (solicitacoes: ItemHistoricoSolicitacaoExameModel[]) => {
  return solicitacoes.some((solicitacaoExame) => hasMamografiaCode(solicitacaoExame))
}
